import React from "react";
import './book-page.css';
import EpicMoney from '../../Images/books/makeepic.jpg';



const  Review11 = () => {
  return (
        <div>
            <div className="book-page-box">
                <div class="book-header ">
                   <div className="book-img">
                   <img src={EpicMoney} alt="MakeEpicMoney"/>
                   </div>
                   
                   <div class="book-title">
                 <h1>Make Epic Money</h1> 
       <p class="author"> by Ankur Warikoo</p>
         
       <p>  Book review by <i> Prabhjot Kaur and Harshita Soni</i></p>
           
                </div>
                </div>
               

            <div className="book-para">
                <p>
                A book’s job isn’t just to hold your attention—it’s to spark your curiosity and make you want to keep reading. 
                And when it comes to learning from mistakes,who better to guide you than someone who’s openly owned up to their financial missteps? 
                Ankur Warikoo does just that in <i>Make Epic Money</i>,sharing lessons that feel honest,practical, and deeply personal. <br />

                
                <i>Make Epic Money</i> is one of the best books on finance out there. At first,it might seem like a simple amalgamation of ideas 
                from classics like <i>Rich Dad Poor Dad or The Psychology of Money</i>—and yes, it is written in the simplest language possible but it goes far beyond that. <br />
                
                Warikoo masterfully breaks down complex financial concepts with relatable, everyday examples. His writing feels more 
                like a heart-to-heart conversation with an elder brother than a lecture. The book covers not just investment strategies but also saving habits, 
                how to allocate your income proportionately, and crucial aspects of life like health and life insurance—topics rarely explained with such clarity and depth. <br />

                
                What makes the book so captivating is its accessibility. You don’t need a background in finance to understand it, and the conversational tone makes it hard to put down. 
                It’s engaging,practical, and incredibly insightful—a true guide for anyone looking to get their financial life in order.
                
                <br /><br />
                
                <h2>Highlights</h2>
                    
                    <ul>
                        <li>It covers all age groups, irrespective of if you are in your 20’s,30’s,40’s and what possible methods you can implement according to your age. </li>
                        <li> It is not necessary to have a particular amount of money to plan and budget, this book covers various categories according to your earnings per annum </li>
                        <li> This book has various QR codes which you can use instantly by just scanning and using those tools. </li>
                        <li>It doesn't provide knowledge about starting a business from scratch , but about how to make more money from money. </li>
                        <li>It covers all major concepts regarding money like our mindset, compounding, insurances, SIPs,etc. </li>
                        <li>Makes one learn things on the basis of the author's past experiences and real life examples like sunk lost fallacy, framing effect, mental accounting,etc. </li>
                    </ul>
                    <br/>
                    
                    <h4>Our favourite quotes from the book were : </h4>
                    
                    <ul>
                        <li>‘Money has a little to do with how smart you are and a lot to do with how you behave and behaviour is hard to teach, even to really smart people.’ —Morgan Housel</li>
                        <li>‘If you don’t design your own life plan, chances are that you’ll fall into someone else’s and guess what they have planned for you? Not much.’ —Jim Rohn</li>
                    </ul>
                    <br/>
                    </p>

                        </div>


                         </div>
                         </div>
                       
  );
};

export default Review11;